module.exports = __webpack_public_path__ + "img/dwdh.4e23b122.png";